const CLIENT_VERSION_DATE_ISO_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/

/** ISO 8601 `YYYY-MM-DDTHH:mm:ss` момента сборки бандла; задаётся при `npm run build:*`. */
function formatNowIsoLocal(): string {
  const now = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
}

/** Если дата сборки не задана (локальный запуск), возвращает текущую локальную дату в ISO. */
export function getClientVersionDate(): string {
  const raw = import.meta.env.VITE_APP_BUILD_DATE?.trim()
  if (!raw || !CLIENT_VERSION_DATE_ISO_RE.test(raw)) return formatNowIsoLocal()
  return raw
}
